import type { IMultiColumnProps } from 'blocks/MultiColumns'

import { styled } from '@linaria/react'
import { MultiColumnsItemStyled, MultiColumnsStyled } from 'blocks/MultiColumns'
import { MEDIA } from 'vars/index'

export const MultiColumnsEpgBlockSC = styled.div<IMultiColumnProps>`
  & ${MultiColumnsStyled} {
    ${MultiColumnsItemStyled} {
      &:nth-child(2) {
        overflow: hidden;
        flex: 1;
        max-width: 800px;
      }
    }

    ${MEDIA.MIN_768} {
      > :last-child {
        padding-top: 0;
      }

      ${MultiColumnsItemStyled} {
        &:first-child {
          width: auto;
        }
      }

      width: ${({ width }) => (width ? `${width}%` : 'auto')};
      column-count: ${({ columnValue }) =>
        columnValue ? `${columnValue}` : '2'};
      -webkit-column-count: ${({ columnValue }) =>
        columnValue ? `${columnValue}` : '2'};
      flex-wrap: nowrap;
    }
  }
`
